import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class StripeInvoiceQueryService {

  public CREATE_STRIPE_INVOICE_DATA: any;
  public GET_STRIPE_INVOICE: any;
  public GET_STRIPE_INVOICE_BY_ORDERID: any;
  public GET_ORDER_BASED_STRIPE_INVOICE: any;

  constructor(public apollo: Apollo) {
    // Create invoice
    this.CREATE_STRIPE_INVOICE_DATA = gql`
            mutation CREATE_INSPECTION_REPORT_MUTATION($input: CreateStripeinvoiceInput!) {
                 createStripeinvoice(input: $input) {
                        stripeinvoice{
                                orderId
                        }
                }
            }
        `;

    //get all invoice details
    this.GET_STRIPE_INVOICE =
      gql`
       query getAllStripes{
             allStripeinvoices {
                     nodes {
                        orderId
                        invoiceObject
                        chargeObject
                        invoiceid
                        id
                     }
             }
         }
     `;
    this.GET_STRIPE_INVOICE_BY_ORDERID = gql`
     query getStripesById($orderId:Int!){
        allStripeinvoices(condition:{orderId:$orderId}) {
                nodes {
                   orderId
                   invoiceObject
                   chargeObject
                   invoiceid
                   id
                }
        }
    }
     `;
    this.GET_ORDER_BASED_STRIPE_INVOICE =
      gql`
            query getAllStripes($orderId: Int!) {
              allStripeinvoices(filter: {orderId: {equalTo: $orderId}}) {
                nodes {
                  orderId
                  invoiceObject
                  chargeObject
                  invoiceid
                  id
                }
              }
            }
     `;
  }

  // Create invoice
  CREATE_STRIPE_INVOICE_DATA_MUTATION(orderId, invoice) {
    return this.apollo.mutate({
      mutation: this.CREATE_STRIPE_INVOICE_DATA,
      variables: {
        "input": {
          "stripeinvoice": {
            "orderId": Number.parseInt(orderId),
            "invoiceObject": JSON.stringify(invoice),
          }
        }
      },
    })
  }

  //get all invoice details
  GET_ALL_STRIPE_INVOICES(): any {
    return this.apollo
      .watchQuery({
        query: this.GET_STRIPE_INVOICE,
        fetchPolicy: 'network-only'
      });
  }
  //get Invoice by order id
  GET__STRIPE_INVOICES_BY_ID(orderId): any {
    return this.apollo
      .watchQuery({
        query: this.GET_STRIPE_INVOICE_BY_ORDERID,
        variables: {
          "orderId": orderId
        },
        fetchPolicy: 'network-only'
      });
  }

  //get order based invoice details
  GET_ORDER_BASED_STRIPE_INVOICES(orderId): any {
    return this.apollo
      .watchQuery({
        query: this.GET_ORDER_BASED_STRIPE_INVOICE,
        variables: {
          "orderId": orderId
        },
        fetchPolicy: 'network-only'
      });
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/stripeInvoices.ts